import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Card, Heading, Subheading, TextStyle, DisplayText, Popover, ActionList, Stack, Button, Spinner, DatePicker, Tooltip } from '@shopify/polaris';
import SalesLineChart from './SalesLineChart';
import SoldItemStats from './SoldItemStats';
import DateActionList from 'components/presentational/DateActionList';

const propTypes = {
  data: PropTypes.shape({
    orders_count: PropTypes.number.isRequired,
    sale_amounts: PropTypes.arrayOf(PropTypes.shape({
      currency_symbol: PropTypes.string.isRequired,
      amount: PropTypes.string.isRequired,
      currency_name: PropTypes.string.isRequired,
    })),
    sold_best: PropTypes.array.isRequired,
    sold_less: PropTypes.array.isRequired,
    sales_over_time: PropTypes.array.isRequired, // for Chart
  }).isRequired,

  dateOptions: PropTypes.array.isRequired,
  onFilter: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

const defaultProps = {
  loading: false
}

const SaleReportOverview = (props) => {
  const [selectedDateLabel, setSelectedDateLabel] = useState("Mes a la fecha");

  const handleDateChange = (value, label, dates = null) => {
    setSelectedDateLabel(label);
    props.onFilter(value, dates);
  }

  return (
    <div>
      <Card.Section>
        <Stack distribution="equalSpacing">
          <div>{ props.loading && <Spinner size="small" /> }</div>
          <DateActionList
            loading={ props.loading }
            onChange={ handleDateChange }
            options={ props.dateOptions }
            defaultDateOptionValue={"date_month"}
          />
        </Stack>
      </Card.Section>
      {/* Card.Header is used as header for first section (main statistics) */}
      <div className="section-top-border">
        <Card.Header title={ 
            <Tooltip content="Número de ventas incluyendo IVA a partir del momento en que se genero la salida de mercaderia">
              <div style={{ display: "inline-block", borderBottom: "2px dotted #c2c2c2", cursor: "pointer" }}><Subheading element="h3">VENTAS APU</Subheading> </div>
            </Tooltip>
          }>
          <div>
            <TextStyle variation="subdued">
              <p>{ selectedDateLabel }</p>
              <p>{ props.data.orders_count } ordenes</p>
            </TextStyle>
          </div>
        </Card.Header>
      </div>
      
      <Card.Section>
        { props.data.sale_amounts.map( (data) => (
          <DisplayText key={ data.currency_symbol } size="large">{ data.currency_name } { data.formatted_amount }</DisplayText>
        ))}
        <div className="mt10">
          <Subheading>Ventas APU en el tiempo</Subheading>
          <div className="mt20">
            <SalesLineChart data={ props.data.sales_over_time } />
          </div>
        </div>
      </Card.Section>

      <Card.Section title="5 MÁS VENDIDOS">
        <SoldItemStats items={ props.data.sold_best } />
      </Card.Section>

      <Card.Section title="5 MENOS VENDIDOS">
        <SoldItemStats items={ props.data.sold_less } />
      </Card.Section>
    </div>
  )
};

SaleReportOverview.propTypes = propTypes;
SaleReportOverview.defaultProps = defaultProps;

export default SaleReportOverview;